import { Get } from "services/apiService";
import { BASE_URL, SOMS_API_KEY } from "services/CONSTANTS";
import {
  GET_PO_CONFIG_REQUEST,
  GET_PO_CONFIG_SUCCESS,
  GET_PO_CONFIG_ERROR,
} from "redux/actions/action-type";

export const getPOConfigurations =
  () =>
  async (dispatch) => {
    const apiUrl = `${BASE_URL}configurations?configType=manualPurchaseOrder&apikey=${SOMS_API_KEY}`;
    dispatch({ type: GET_PO_CONFIG_REQUEST });
    Get({ url: apiUrl })
      .then((response) => {
        if (response.status === 200)
          dispatch({ type: GET_PO_CONFIG_SUCCESS, payload: response.data });
        else
          dispatch({ type: GET_PO_CONFIG_ERROR });
      })
      .catch(() => {
        dispatch({ type: GET_PO_CONFIG_ERROR });
      });
  };
